import { useCallback } from 'react';
import { TabGroup, Tab } from 'ui/tabs';
import { WorkflowType } from 'modules/workflows/enums';

import {
  WORKFLOW_STATUS_FILTER,
  WORKFLOW_STATUS_FILTER_WITH_DRAFTS,
  WORKFLOW_STATUS_FILTER_WITH_DRAFTS_OPTIONS,
  DISABLED_WORKFLOW_STATUS_FILTER_TABS,
} from '../constants';

type FiltersBarProps = {
  statusFilterIds: string[];
  setStatusFilterIds: (statusFilterIds: string[]) => void;
  workflowTypeFilterIds: string[];
  setWorkflowTypeFilterIds: (workflowTypeFilterIds: string[]) => void;
};

const getWorkflowStatusFilterWithDraftsTabs = () =>
  WORKFLOW_STATUS_FILTER_WITH_DRAFTS_OPTIONS.filter(
    ({ id }) => !DISABLED_WORKFLOW_STATUS_FILTER_TABS.includes(id),
  );

const getSelectedTab = (
  statusFilterIds: FiltersBarProps['statusFilterIds'],
  workflowTypeFilterIds: FiltersBarProps['workflowTypeFilterIds'],
) => {
  const filters = [...statusFilterIds, ...workflowTypeFilterIds];
  /**
   * Not all status filters have a filter tab with ff
   * i.e. hasDraft
   */
  const isTabDisabled = DISABLED_WORKFLOW_STATUS_FILTER_TABS.includes(
    statusFilterIds[0] as WORKFLOW_STATUS_FILTER_WITH_DRAFTS,
  );

  if (statusFilterIds.length === 1 && isTabDisabled) return WorkflowType.DRAFT;
  if (filters.length === 1) return filters[0];

  return WORKFLOW_STATUS_FILTER.ALL;
};

const getFilters = (filterId: string) => ({
  [filterId]: {
    workflowTypeFilters: [],
    statusFilters: [filterId],
  },
  [WORKFLOW_STATUS_FILTER.ALL]: {
    workflowTypeFilters: [],
    statusFilters: [],
  },
  [WorkflowType.DRAFT]: {
    workflowTypeFilters: [WorkflowType.DRAFT],
    statusFilters: [WORKFLOW_STATUS_FILTER_WITH_DRAFTS.HAS_DRAFT],
  },
});

export const FiltersTabs = ({
  workflowTypeFilterIds,
  setWorkflowTypeFilterIds,
  statusFilterIds,
  setStatusFilterIds,
}: FiltersBarProps) => {
  return (
    <TabGroup
      selectedTab={getSelectedTab(statusFilterIds, workflowTypeFilterIds)}
      onTabChange={useCallback(
        (filterId: any) => {
          const { workflowTypeFilters, statusFilters } = getFilters(filterId)[filterId];
          setWorkflowTypeFilterIds(workflowTypeFilters);
          setStatusFilterIds(statusFilters);
        },
        [setStatusFilterIds, setWorkflowTypeFilterIds],
      )}
    >
      {getWorkflowStatusFilterWithDraftsTabs().map(({ id, label }) => (
        <Tab key={id} id={id}>
          {label}
        </Tab>
      ))}
    </TabGroup>
  );
};
